import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type StandbyRelationPaletteCardTemplateJoinedDb = {
  jointPaletteId: string;
  paletteId: string;
  cardTemplateId: string;
  order: number;
}
const initial: StandbyRelationPaletteCardTemplateJoinedDb = {
  jointPaletteId: '',
  paletteId: '',
  cardTemplateId: '',
  order: 0
};

export type StandbyRelationPaletteCardTemplateJoinedDbHashType = {
  [key in string]: StandbyRelationPaletteCardTemplateJoinedDb;
}

export type StandbyRelationPaletteCardTemplateJoinedAddPayload = {
  id?: string;
} & StandbyRelationPaletteCardTemplateJoinedDb;
export type StandbyRelationPaletteCardTemplateJoinedUpdatePayload = {
  id: string;
} & { [P in keyof StandbyRelationPaletteCardTemplateJoinedDb]?: StandbyRelationPaletteCardTemplateJoinedDb[P] };

export type StandbyRelationPaletteCardTemplateJoinedDbState = {
  standbyRelationPaletteCardTemplateJoineds: StandbyRelationPaletteCardTemplateJoinedDbHashType;
}

export const generateStandbyRelationPaletteCardTemplateJoinedId = (): string => generateId('srpct');
let initialState: StandbyRelationPaletteCardTemplateJoinedDbState = { standbyRelationPaletteCardTemplateJoineds: {} };
const key = 'standbyRelationPaletteCardTemplateJoineds';

const standbyRelationPaletteCardTemplateJoinedDbSlice = createSlice({
  name: 'standbyRelationPaletteCardTemplateJoinedDb',
  initialState,
  reducers: {
    initializeStandbyRelationPaletteCardTemplateJoineds(state: StandbyRelationPaletteCardTemplateJoinedDbState) {
      state.standbyRelationPaletteCardTemplateJoineds = {};
    },
    addStandbyRelationPaletteCardTemplateJoined(state: StandbyRelationPaletteCardTemplateJoinedDbState, action: PayloadAction<StandbyRelationPaletteCardTemplateJoinedAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateStandbyRelationPaletteCardTemplateJoinedId();
      state.standbyRelationPaletteCardTemplateJoineds[id] = obj;
      saveData(key, id, obj);
    },
    updateStandbyRelationPaletteCardTemplateJoined(state: StandbyRelationPaletteCardTemplateJoinedDbState, action: PayloadAction<StandbyRelationPaletteCardTemplateJoinedUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.standbyRelationPaletteCardTemplateJoineds[id] === undefined) {
        console.log(`*** StandbyRelationPaletteCardTemplateJoined not found: ${id}`);
      } else {
        const newData = { ...state.standbyRelationPaletteCardTemplateJoineds[id], ...obj };
        state.standbyRelationPaletteCardTemplateJoineds[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteStandbyRelationPaletteCardTemplateJoined(state: StandbyRelationPaletteCardTemplateJoinedDbState, action: PayloadAction<StandbyRelationPaletteCardTemplateJoinedUpdatePayload>) {
      const id = action.payload.id;
      delete state.standbyRelationPaletteCardTemplateJoineds[id];
      deleteData(key, id);
    },
    saveStandbyRelationPaletteCardTemplateJoineds(state: StandbyRelationPaletteCardTemplateJoinedDbState) {
      saveAllData(key, state.standbyRelationPaletteCardTemplateJoineds);
    },
    signUpStandbyRelationPaletteCardTemplateJoineds(state: StandbyRelationPaletteCardTemplateJoinedDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.standbyRelationPaletteCardTemplateJoineds, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: StandbyRelationPaletteCardTemplateJoinedDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.standbyRelationPaletteCardTemplateJoineds = updatedValues;
      if (changed) saveAllData(key, state.standbyRelationPaletteCardTemplateJoineds);
    })
  }
})

export const { initializeStandbyRelationPaletteCardTemplateJoineds, addStandbyRelationPaletteCardTemplateJoined, updateStandbyRelationPaletteCardTemplateJoined, deleteStandbyRelationPaletteCardTemplateJoined, saveStandbyRelationPaletteCardTemplateJoineds, signUpStandbyRelationPaletteCardTemplateJoineds } = standbyRelationPaletteCardTemplateJoinedDbSlice.actions;
export default standbyRelationPaletteCardTemplateJoinedDbSlice.reducer;
